const tagline = 'One unified cloud platform to achieve your security, compliance, and operational objectives.';

export {tagline};

